/* eslint-disable no-case-declarations */
/* eslint-disable no-fallthrough */
import styled from 'styled-components';
import { LOCATION_CHANGE } from 'connected-react-router';
import { ModalContent } from '@carvana/modal';
import * as types from './action-types';
import { Content } from '../dashboard-modal.styles';

const dashboardModalState = {
  awaitModalChildLoad: false,
  closeModalCallback: () => {},
  headerText: '',
  isFullscreenOnMobile: true,
  ModalChildren: null,
  modalContentStyles: null,
  modalData: {},
  modalIsLoading: false,
  modalIsOpen: false,
  modalOneTimeLoad: false,
  modalProps: null
};

export default function reducer(state = dashboardModalState, action) {
  const { payload } = action;

  switch (action.type) {
    case types.DASHBOARD_MODAL_CLOSED:
      return {
        ...dashboardModalState,
        modalIsOpen: false
      };

    case types.DASHBOARD_MODAL_OPENED: {
      const { modalContentStyles } = payload;
      const modalStyles = modalContentStyles
        ? styled(ModalContent)`
            ${modalContentStyles}
          `
        : Content;

      return {
        ...state,
        ...payload,
        modalStyles,
        modalIsOpen: true,
        modalOneTimeLoad: action?.payload.isOneTimeLoad
      };
    }

    case types.DASHBOARD_MODAL_LOADED:
      const cb = payload?.closeModalCallback || state.closeModalCallback;

      return {
        ...state,
        headerText: payload?.headerText || state.headerText,
        closeModalCallback: cb,
        modalIsLoading: false
      };

    case types.DASHBOARD_MODAL_LOADING:
      return {
        ...state,
        modalIsLoading: true
      };

    case LOCATION_CHANGE: {
      if (state?.modalIsOpen && !state?.modalOneTimeLoad) {
        return {
          ...state,
          modalIsOpen: false
        };
      }

      return {
        ...state
      };
    }

    default:
      return state;
  }
}

export const Initialize = registry =>
  registry.register('dashboardModal', reducer, dashboardModalState);
